import { render, staticRenderFns } from "./Carrusel.vue?vue&type=template&id=60a24954&"
import script from "./Carrusel.vue?vue&type=script&lang=js&"
export * from "./Carrusel.vue?vue&type=script&lang=js&"
import style0 from "./Carrusel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
